import React from "react";

import styles from "./column.module.scss";

export const StyledColumn: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.styledColumn} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const StyledColumnDroppable: React.FC<
  { isDraggingOver: boolean } & React.HTMLAttributes<HTMLDivElement>
> = ({ isDraggingOver, children, className, style, ...rest }) => (
  <div
    className={`${styles.styledColumnDroppable} ${className ?? ""}`}
    style={{
      ...style,
      background: isDraggingOver
        ? "var(--mantine-color-main-2)"
        : "var(--mantine-color-tdBackgroundColor-0)",
    }}
    {...rest}>
    {children}
  </div>
);
